import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import type { ChangeSingleCriteriaAction, CriteriaDimension, PaginationCriteria } from '@openx/types/tableCriteria';
import type { JSX, ReactNode } from 'react';
import { PaginationNav } from './PaginationNav';

export interface ManagementSectionProps {
  customManagementSection?: ReactNode;
  loading: boolean;
  paginationCriteria?: PaginationCriteria;
  onPaginationChange: ChangeSingleCriteriaAction<typeof CriteriaDimension.PAGINATION>;
}

const StyledContainerGrid = styled(Grid)`
  background-color: ${({ theme }) => theme.palette.background.boxLight};
  border-color: ${({ theme }) => theme.palette.divider};
  border-style: solid;
  border-width: 0;
  color: ${({ theme }) => theme.palette.text.secondary};
  height: 50px;
  padding: ${({ theme }) => theme.spacing(0, 2.5)};

  &:first-of-type {
    border-bottom-width: 1px;
  }

  *:not(:first-of-type) > &:first-of-type {
    border-top-width: 1px;
  }
`;

const StyledManagementSectionContainerGrid = styled(Grid)`
  flex-grow: 1;
  margin-right: ${({ theme }) => theme.spacing(1)};
`;

export function ManagementSection(props: ManagementSectionProps): JSX.Element | null {
  const { customManagementSection, loading, paginationCriteria, onPaginationChange } = props;

  if (!customManagementSection && !paginationCriteria) {
    return null;
  }

  return (
    <StyledContainerGrid container sx={{ alignItems: 'center' }}>
      <StyledManagementSectionContainerGrid>{customManagementSection}</StyledManagementSectionContainerGrid>
      <Grid>
        {paginationCriteria && (
          <PaginationNav onChange={onPaginationChange} loading={loading} paginationParams={paginationCriteria} />
        )}
      </Grid>
    </StyledContainerGrid>
  );
}
